import React from "react";
import { Card, Input, Button, Modal, Select, message, Popconfirm, DatePicker } from "antd";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Row, Col, Form, FormGroup, Label, Spinner } from 'reactstrap';
import Media from 'react-media';


import { services } from '../../../services/services';

import { authenticationService } from "../../../services/authentication-service";
import { use_logiciel } from '../../../env'


const currentUser = authenticationService.currentUserValue;

const moment = require('moment')
//const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];
const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;

class Depenses extends React.Component {
    state = {
        isModalVisible: false,
        isAddModalVisible: false,
        isUpdateModalVisible: false,
        isAddNatureModalVisible: false,
        loading: false,
        depenses: [],
        natures: [],
        agences: [],

        codeDep: '',
        libelleDep: '',
        codeNatDep: '',
        montantDep: 0,
        observation: '',
        codAgenceChange: '',

        startDate: moment(),
        endDate: moment(),

        waitingEndMsg: '',
        isLoading: true,
    }


    openNatureAdd = () => {
        this.setState({ isAddNatureModalVisible: !this.state.isAddNatureModalVisible })
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleAddNature = () => {
        const {
            //codeNatDep,
            libelleNatDep,

        } = this.state


        if (libelleNatDep === '') {
            message.warning('Veuillez préciser le libellé de la nature', 5)
            return;
        }

        this.setState({ loading: true })
        let req = {
            //codeNatDep,
            libelleNatDep: libelleNatDep.toUpperCase(),

        }
        services.addNatureDepense(req)
            .then(result => {
                // console.log(result)
                this.setState({
                    codeNatDep: '',
                    loading: false,
                    libelleNatDep: '',

                    isAddNatureModalVisible: !this.state.isAddNatureModalVisible,

                })
                message.success('Nature ajouter avec succès', 10)

                services.getNatureDepense()
                    .then(natures => {
                        this.setState({ natures })
                    })

            })

            .catch((err) => {
                this.setState({ loading: false })
                message.error(err, 10)
            });
    }

    componentDidMount() {
        const startDate = moment(new Date(), 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(new Date(), 'DD/MM/YYYY').format('YYYY-MM-DD')

        services.getDepense('', startDate, endDate)
            .then(depenses => {
                console.log('depenses', depenses)
                this.setState({ depenses })
                setTimeout(() => {

                    // console.log("real depenses", factures)
                    if (!depenses || !Array.isArray(depenses)
                        || !depenses.length > 0) {
                        this.setState({ isLoading: false, waitingEndMsg: "Vous n'avez aucune Dépense actuellement !" })
                    }
                }, 500)
            })
            .catch(() => {
                message.error('Une erreur est survenue lors du chargement des données, Veuillez réessayer plus tard', 10)
                this.setState({ isLoading: false, waitingEndMsg: "Une erreur est survenue lors du chargement des données, Veuillez réessayer plus tard!" })

            });

        services.getNatureDepense()
            .then(natures => {
                //console.log('Roles', roles)
                this.setState({ natures })
            })
        services.getAllAgences()
            .then(agences => {
                //  //console.log('agences', agences)
                this.setState({ agences })
            })

    }

    onDateChange = (date, dateString) => {
        // //console.log("DATE", date, dateString, dateString[0]);
        this.setState({ isLoading: true, factures: [] })

        const startDate = moment(dateString[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(dateString[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
        //  //console.log("DATE CHANGE PERIODE", dateString[0], dateString[1], this.state.dateEnCours, this.state.codAgenceChange, startDate, endDate)

        services.getDepense(this.state.codAgenceChange, startDate, endDate)
            .then(depenses => {
                console.log('depenses', depenses)
                this.setState({ depenses })
                setTimeout(() => {

                    // console.log("real depenses", factures)
                    if (!depenses || !Array.isArray(depenses)
                        || !depenses.length > 0) {
                        this.setState({ isLoading: false, waitingEndMsg: "Vous n'avez aucune Dépense actuellement !" })
                    }
                }, 500)
            })
            .catch(() => {
                message.error('Une erreur est survenue lors du chargement des données, Veuillez réessayer plus tard', 10)
                this.setState({ isLoading: false })

            });

        this.setState({ startDate: dateString[0], endDate: dateString[1] })

    }

    handleChangeAgence = (value) => {

        const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.setState({ codAgenceChange: value })
        this.setState({ isLoading: true, waitingEndMsg: '', depenses: [] })
        //  //console.log("AGENCE CHANGE", this.state.dateEnCours,value, startDate, endDate)

        services.getDepense(value, startDate, endDate)
            .then(depenses => {
                console.log('depenses', depenses)
                this.setState({ depenses })
                setTimeout(() => {

                    // console.log("real depenses", factures)
                    if (!depenses || !Array.isArray(depenses)
                        || !depenses.length > 0) {
                        this.setState({ isLoading: false, waitingEndMsg: "Vous n'avez aucune Dépense actuellement !" })
                    }
                }, 500)
            })
            .catch(() => {
                message.error('Une erreur est survenue lors du chargement des données, Veuillez réessayer plus tard', 10)
                this.setState({ isLoading: false })

            });
    }


    handleAddOpen = () => {
        this.setState({
            isAddModalVisible: !this.state.isAddModalVisible,
            codeDep: '',

            libelleDep: '',
            codeNatDep: '',
            montantDep: 0,
            observation: '',
            dateDep: '',

            loading: false,
        });
    };

    handleCancelAdd = () => {
        this.setState({
            isAddModalVisible: !this.state.isAddModalVisible,
            codeDep: '',

            libelleDep: '',
            codeNatDep: '',
            montantDep: 0,
            observation: '',
            dateDep: '',
        })
    }

    handleAddDepense = () => {
        const {

            codeNatDep,
            //codeDep,
            libelleDep,
            montantDep,
            observation,

        } = this.state


        if (libelleDep === '') {
            message.warning('Veuillez préciser le Libellé de l\'Opération', 5)
            return;
        }

        if (montantDep === 0) {
            message.warning('Veuillez préciser le montant de l\'Opération', 5)
            return;
        }

        if (codeNatDep === '' || codeNatDep === null || codeNatDep === undefined) {
            message.warning('Veuillez sélectionner une nature de Dépense', 5)
            return;
        }


        this.setState({ loading: true })

        let req = {
            // codeDep,
            libelleDep: libelleDep.toUpperCase(),
            montantDep,
            codeNatDep,
            observation,

        }
        services.addDepense(req)
            .then(result => {
                // console.log(result)
                this.setState({
                    codeDep: '',
                    libelleDep: '',
                    montantDep: 0,
                    codeNatDep: '',
                    observation: '',
                    isAddModalVisible: !this.state.isAddModalVisible,
                    loading: false,

                })
                message.success('Dépense ajouter avec succès', 10)

                const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

                services.getDepense('', startDate, endDate)
                    .then(depenses => {
                        this.setState({ depenses })
                    })

            })

            .catch((err) => {
                message.error(err, 10)
            });
    }

    handleUpdateDepense = () => {
        const {

            codeNatDep,
            codeDep,
            libelleDep,
            montantDep,
            observation,

        } = this.state


        if (libelleDep === '') {
            message.warning('Veuillez préciser le Libellé de l\'Opération', 5)
            return;
        }

        if (montantDep === 0) {
            message.warning('Veuillez préciser le montant de l\'Opération', 5)
            return;
        }

        if (codeNatDep === '' || codeNatDep === null || codeNatDep === undefined) {
            message.warning('Veuillez sélectionner une nature de Dépense', 5)
            return;
        }

        this.setState({ loading: true })


        let req = {
            codeDep,
            libelleDep: libelleDep.toUpperCase(),
            montantDep,
            codeNatDep,
            observation,

        }
        services.updateDepense(req)
            .then(result => {
                // console.log(result)
                this.setState({
                    codeDep: '',
                    libelleDep: '',
                    montantDep: 0,
                    codeNatDep: '',
                    observation: '',
                    isUpdateModalVisible: !this.state.isUpdateModalVisible,
                    loading: false,

                })
                message.success('Dépense modifier avec succès', 10)

                const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

                services.getDepense('', startDate, endDate)
                    .then(depenses => {
                        this.setState({ depenses })
                    })

            })

            .catch(() => {
                message.error('Une erreur est survenue lors de la modification, Veuillez réessayer plus tard', 10)
            });
    }

    handleDelete = (row) => {
        this.setState({
            codeDep: row.codeDep,

            libelleDep: row.libelleDep,
        })

    }

    handleDeleteDepense = () => {

        const { codeDep } = this.state

        services.deleteDepense(codeDep)
            .then(del => {
                //console.log('delete user', del)
                message.success('Dépense supprimer avec succès', 10)

                
                const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

                services.getDepense('', startDate, endDate)
                    .then(depenses => {
                        this.setState({ depenses })
                    })
            })
            .catch((err) => {
                //console.log(err)
                message.error(err, 10)
            });

    }

    handleUpdateOpen = (row) => {
        this.setState({
            isUpdateModalVisible: !this.state.isUpdateModalVisible,
            //idArticle: row.id,
            codeDep: row.codeDep,
            libelleDep: row.libelleDep,
            codeNatDep: row.natureDepense && row.natureDepense.codeNatDep,
            montantDep: parseFloat(row.montantDep),
            observation: row.observation,
            dateDep: row.dateDep,
            agence: row.agences && row.agences.nomAgence,
            user: row.user && row.user.username,

        })

    }
    handleCancelUpdate = () => {
        this.setState({
            isUpdateModalVisible: !this.state.isUpdateModalVisible,
            codeDep: '',
            libelleDep: '',
            montantDep: 0,
            codeNatDep: '',
            observation: '',

        })
    }


    handleView = (row) => {
        // console.log('ROW', row)
        this.setState({
            isModalVisible: !this.state.isModalVisible,

            codeDep: row.codeDep,
            libelleDep: row.libelleDep,
            codeNatDep: row.natureDepense && row.natureDepense.codeNatDep,
            montantDep: parseFloat(row.montantDep),
            observation: row.observation,
            dateDep: row.dateDep,
            agence: row.agences && row.agences.nomAgence,
            user: row.user && row.user.username,
        });
    };

    handleCancel = () => {
        this.setState({
            isModalVisible: false,
            codeDep: '',
            libelleDep: '',
            montantDep: 0,
            codeNatDep: '',
            observation: '',
        });
    }

    handleChangeNature = (value) => {
        this.setState({ codeNatDep: value })
        // console.log(`selected ${value} ${this.state.codeNatDep}`);
    }

    handleBlur = () => {
        //  console.log('blur');
    }

    handleFocus = () => {
        // console.log('focus');
    }




    render() {
        const {
            isModalVisible,
            loading,


            libelleDep,
            codeNatDep,
            codeDep,
            montantDep,
            observation,
            user,
            agence,
            dateDep,
            libelleNatDep,



            depenses,
            natures,
            codAgenceChange,
            agences,
            endDate,
            startDate,

            isAddModalVisible,
            isUpdateModalVisible,
            isAddNatureModalVisible,

            isLoading,
            waitingEndMsg,

        } = this.state

        const InputGroup = Input.Group;
        const Option = Select.Option;

        const { SearchBar } = Search;

        const columnsDepenses = [
            /*{
            dataField: 'id',
            text: ' ID'
          },*/
            {
                dataField: 'codeDep',
                text: ' Code'
            },

            {
                dataField: 'libelleDep',
                text: ' Libellé '
            },

            {
                dataField: 'montantDep',
                text: 'Montant '
            },
            {
                dataField: 'natureDepense',
                text: 'Nature',
                formatter: (cell, row, rowIndex, formatExtraData) => {
                    return (
                        < div
                            style={{ textAlign: "center" }} className="d-flex">
                            {row && row.natureDepense && row.natureDepense.libelleNatDep}
                        </div>
                    );
                },
            },
            {
                dataField: 'user',
                text: 'Opérateur',
                formatter: (cell, row, rowIndex, formatExtraData) => {
                    return (
                        < div
                            style={{ textAlign: "center" }} className="d-flex">
                            {row && row.user && row.user.username}
                        </div>
                    );
                },
            },
            {
                dataField: 'agences',
                text: 'Agence',
                formatter: (cell, row, rowIndex, formatExtraData) => {
                    return (
                        < div
                            style={{ textAlign: "center" }} className="d-flex">
                            {row && row.agences && row.agences.nomAgence}
                        </div>
                    );
                },
            },


            // (currentUser.agence.enCours===true && currentUser.slug==="ADMIN_ROLE"  ) &&
            {
                dataField: '',
                text: 'Action',
                headerAlign: 'center',
                sort: true,
                headerAttrs: { width: 50 },
                align: 'center',
                hidden: ((currentUser && currentUser.agence && currentUser.agence.enCours === false && currentUser.slug === "AGENT_ROLE") || (currentUser && currentUser.agence && currentUser.agence.enCours === false && currentUser.slug === "ADMIN_ROLE")) ? true : false,
                formatter: (cell, row, rowIndex, formatExtraData) => {
                    return (
                        < div
                            style={{ textAlign: "center" }} className="d-flex">
                            <Button
                                type="primary"
                                //fullWidth
                                variant="contained"
                                color="primary"
                                size="small"
                                //className="btn btn-success btn-sm"
                                onClick={() => this.handleView(row)}
                            >
                                <i className="icon icon-custom-view" />
                            </Button>
                            <Button
                                hidden={use_logiciel === 'NO' ? false : true}
                                type="primary"
                                //fullWidth
                                variant="contained"
                                color="danger"
                                size="small"
                                //className="btn btn-success btn-sm"
                                onClick={() => this.handleUpdateOpen(row)}
                            >
                                <i className="icon icon-edit" />
                            </Button>
                            <Popconfirm placement="left" title="Êtes vous sûr de vouloir supprimer cette Dépense?" onConfirm={this.handleDeleteDepense} onCancel={this.cancelDelete} okText="Oui"
                                cancelText="Non">
                                <Button
                                    hidden={use_logiciel === 'NO' ? false : true}
                                    type="danger"
                                    //fullWidth
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    //className="btn btn-success btn-sm"
                                    onClick={() => this.handleDelete(row)}
                                >
                                    <i className="icon icon-alert-new" />
                                </Button>

                            </Popconfirm>

                        </div>
                    );
                },


            }

        ];


        const columnsDepensesPhone = [

            {
                dataField: 'libelleDep',
                text: ' Libellé '
            },

            {
                dataField: 'montantDep',
                text: 'Montant '
            },

            // (currentUser.agence.enCours===true && currentUser.slug==="ADMIN_ROLE"  ) &&
            {
                dataField: '',
                text: 'Action',
                headerAlign: 'center',
                sort: true,
                headerAttrs: { width: 50 },
                align: 'center',
                hidden: ((currentUser && currentUser.agence && currentUser.agence.enCours === false && currentUser.slug === "AGENT_ROLE") || (currentUser && currentUser.agence && currentUser.agence.enCours === false && currentUser.slug === "ADMIN_ROLE")) ? true : false,
                formatter: (cell, row, rowIndex, formatExtraData) => {
                    return (
                        < div
                            style={{ textAlign: "center" }} className="d-flex">
                            <Button
                                type="primary"
                                //fullWidth
                                variant="contained"
                                color="primary"
                                size="small"
                                //className="btn btn-success btn-sm"
                                onClick={() => this.handleView(row)}
                            >
                                <i className="icon icon-custom-view" />
                            </Button>
                            <Button
                                type="primary"
                                //fullWidth
                                variant="contained"
                                color="danger"
                                size="small"
                                //className="btn btn-success btn-sm"
                                onClick={() => this.handleUpdateOpen(row)}
                            >
                                <i className="icon icon-edit" />
                            </Button>
                            <Popconfirm placement="left" title="Êtes vous sûr de vouloir supprimer cette Dépense?" onConfirm={this.handleDeleteDepense} onCancel={this.cancelDelete} okText="Oui"
                                cancelText="Non">
                                <Button
                                    type="danger"
                                    //fullWidth
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    //className="btn btn-success btn-sm"
                                    onClick={() => this.handleDelete(row)}
                                >
                                    <i className="icon icon-alert-new" />
                                </Button>

                            </Popconfirm>
                        </div>
                    );
                },


            }

        ];

        const defaultSorted = [{
            dataField: 'libelleDep',
            order: 'asc'
        }];



        return (
            <div>
                <Card title="Liste des Dépenses">

                    <Media query="(min-width: 600px)" render={() =>
                    (
                        <ToolkitProvider
                            keyField="id"
                            data={depenses}
                            columns={columnsDepenses}
                            //cellEdit={cellEditFactory({ mode: 'dbclick' })}
                            search
                            //insertRow={true}
                            exportCSV

                        >
                            {
                                props => (
                                    <div>
                                        <Row >
                                            <Col md={3} style={{ display: 'flex', alignItems: 'baseline' }}>
                                                {/*<i className="fa fa-search" style={{ margin: 10 }}></i> */}

                                                <SearchBar {...props.searchProps}
                                                    //delay={ 1000 }
                                                    style={{ maxWidth: 350, width: '180%', margin: 'auto', display: 'flex', borderRadius: 50 }}
                                                    placeholder="Rechercher"

                                                />
                                            </Col>

                                            <Col md={9} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', }}>

                                                <FormGroup className="mr-2">
                                                    <RangePicker className="gx-w-100"
                                                        defaultValue={[moment(startDate, dateFormat), moment(endDate, dateFormat)]}
                                                        format={dateFormat}
                                                        onChange={this.onDateChange}
                                                        ranges={{
                                                            "Aujourd'hui": [moment(), moment()],
                                                            'Cette Semaine': [moment().startOf('week'), moment().endOf('week')],
                                                            'Ce Mois': [moment().startOf('month'), moment().endOf('month')],
                                                            'Cette Année': [moment().startOf('year'), moment().endOf('year')]

                                                        }}
                                                    />
                                                    <h6 className="mr-3" style={{ color: "black", }}><span>Filtrer par Période</span></h6>
                                                </FormGroup>


                                                {(currentUser && currentUser.agence && currentUser.agence.enCours === true && currentUser.slug === "ADMIN_ROLE") &&
                                                    <FormGroup>
                                                        <Select

                                                            value={codAgenceChange}
                                                            showSearch
                                                            //style={{width: 200}}
                                                            style={{ width: '120%' }}
                                                            placeholder="Filtrer par Agence"
                                                            optionFilterProp="children"
                                                            onChange={this.handleChangeAgence}
                                                            onFocus={this.handleFocus}
                                                            onBlur={this.handleBlur}
                                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                        >
                                                            <Option value=''>TOUTES</Option>
                                                            {
                                                                agences && agences.length ?
                                                                    agences.map((agence, k) => {
                                                                        return <Option key={k} value={agence.codAgence}>{agence.nomAgence}</Option>
                                                                    }) : null
                                                            }

                                                        </Select>
                                                        <h6 className="mr-3" style={{ color: "black" }}><span>Filtrer par Agence</span></h6>
                                                    </FormGroup>}

                                                {use_logiciel === 'NO' &&
                                                    <button style={{ marginLeft: 35 }}
                                                        className="btn bg-primary text-light rounded"
                                                        onClick={this.handleAddOpen}>
                                                        NOUVEAU <i className="icon icon-add" />
                                                    </button>
                                                }
                                            </Col>
                                        </Row>


                                        <BootstrapTable
                                            {...props.baseProps}
                                            //bootstrap4
                                            wrapperClasses="table-responsive"
                                            //selectRow={ selectRow }
                                            //defaultSorted={defaultSorted}
                                            pagination={paginationFactory()}
                                            defaultSorted={defaultSorted}
                                            striped
                                            hover
                                            condensed
                                            headerWrapperClasses="foo"
                                            noDataIndication="Vous n'avez aucun enrégistrement pour cette période, veuillez cliquer sur Nouveau pour en ajouter"
                                        //filter={filterFactory()}
                                        />

                                    </div>

                                )
                            }
                        </ToolkitProvider>
                    )}
                    />


                    <Media query="(max-width: 599px)" render={() =>
                    (

                        <ToolkitProvider
                            keyField="id"
                            data={depenses}
                            columns={columnsDepensesPhone}
                            //cellEdit={cellEditFactory({ mode: 'dbclick' })}
                            search
                            //insertRow={true}
                            exportCSV

                        >
                            {
                                props => (
                                    <div>
                                        <Row >
                                            <Col md={6} style={{ display: 'flex', alignItems: 'baseline' }}>
                                                <i className="fa fa-search" style={{ margin: 10 }}></i>

                                                <SearchBar {...props.searchProps}
                                                    //delay={ 1000 }
                                                    style={{ maxWidth: 550, width: '125%', margin: 'auto', display: 'flex', borderRadius: 50 }}
                                                    placeholder="Rechercher"

                                                />
                                            </Col>
                                            <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', }}>

                                                <FormGroup className="mr-2">
                                                    <RangePicker className="gx-w-100"
                                                        defaultValue={[moment(startDate, dateFormat), moment(endDate, dateFormat)]}
                                                        format={dateFormat}
                                                        onChange={this.onDateChange}
                                                        ranges={{
                                                            "Aujourd'hui": [moment(), moment()],
                                                            'Cette Semaine': [moment().startOf('week'), moment().endOf('week')],
                                                            'Ce Mois': [moment().startOf('month'), moment().endOf('month')],
                                                            'Cette Année': [moment().startOf('year'), moment().endOf('year')]

                                                        }}
                                                    />
                                                    <h6 className="mr-3" style={{ color: "black", }}><span>Filtrer par Période</span></h6>
                                                </FormGroup>
                                            </Col>

                                            <Col md={6}>
                                                {(currentUser && currentUser.agence && currentUser.agence.enCours === true && currentUser.slug === "ADMIN_ROLE") &&
                                                    <FormGroup>
                                                        <Select

                                                            value={codAgenceChange}
                                                            showSearch
                                                            //style={{width: 200}}
                                                            style={{ width: '100%' }}
                                                            placeholder="Filtrer par Agence"
                                                            optionFilterProp="children"
                                                            onChange={this.handleChangeAgence}
                                                            onFocus={this.handleFocus}
                                                            onBlur={this.handleBlur}
                                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                        >
                                                            <Option value=''>TOUTES</Option>
                                                            {
                                                                agences && agences.length ?
                                                                    agences.map((agence, k) => {
                                                                        return <Option key={k} value={agence.codAgence}>{agence.nomAgence}</Option>
                                                                    }) : null
                                                            }

                                                        </Select>
                                                        <h6 className="mr-3" style={{ color: "black" }}><span>Filtrer par Agence</span></h6>
                                                    </FormGroup>}
                                            </Col>
                                            <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', }}>

                                                {use_logiciel === 'NO' &&
                                                    <button style={{ marginLeft: 35 }}
                                                        className="btn bg-primary text-light rounded"
                                                        onClick={this.handleAddOpen}>
                                                        NOUVEAU <i className="icon icon-add" />
                                                    </button>
                                                }
                                            </Col>

                                        </Row>

                                        {
                                            !isLoading && waitingEndMsg && waitingEndMsg !== '' && <div><h5 className="card-title text-danger">{waitingEndMsg}</h5></div>
                                        }
                                        {
                                            depenses &&
                                                Array.isArray(depenses) &&
                                                depenses.length > 0 ?
                                                <BootstrapTable
                                                    {...props.baseProps}
                                                    //bootstrap4
                                                    wrapperClasses="table-responsive"
                                                    //selectRow={ selectRow }
                                                    //defaultSorted={defaultSorted}
                                                    pagination={paginationFactory()}
                                                    defaultSorted={defaultSorted}
                                                    striped
                                                    hover
                                                    condensed
                                                    headerWrapperClasses="foo"
                                                    noDataIndication="Vous n'avez aucun enrégistrement, veuillez cliquer sur Nouveau pour en ajouter"
                                                //filter={filterFactory()}
                                                />
                                                :
                                                isLoading ?
                                                    <div style={{ justifyContent: 'center' }}>

                                                        <Row style={{ justifyContent: 'center' }}>
                                                            <Col style={{ justifyContent: 'center' }}>
                                                                <Spinner type="grow" color="primary" />
                                                                <Spinner type="grow" color="secondary" />
                                                                <Spinner type="grow" color="success" />
                                                                <Spinner type="grow" color="danger" />
                                                                <Spinner type="grow" color="warning" />
                                                                <Spinner type="grow" color="info" />
                                                                <Spinner type="grow" color="light" />
                                                                <Spinner type="grow" color="dark" />
                                                            </Col>
                                                        </Row> <br />
                                                    </div>
                                                    : null
                                        }

                                    </div>

                                )
                            }
                        </ToolkitProvider>
                    )}
                    />
                </Card>


                <Modal
                    width={800}
                    visible={isAddModalVisible}
                    title="Ajouter une Dépense"
                    //onOk={this.handleAddOpen}
                    onCancel={this.handleCancelAdd}
                    footer={[
                        <Button  type="primary" loading={loading} onClick={this.handleAddDepense}>
                            Envoyer
                        </Button>,
                        <Button type="danger" onClick={this.handleCancelAdd}>
                            Annuler
                        </Button>,

                    ]}
                >
                    <Form>
                        <Row form>


                            <Col md={12}>
                                <FormGroup>
                                    <Label for="libelleDep">Libellé Opération</Label>
                                    <Input type="text" name="libelleDep" value={libelleDep} onChange={this.handleChange} id="libelleDep" placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>



                        <Row form>

                            <Col md={12}>
                                <FormGroup>
                                    <Label for="montantDep">Montant Opération</Label>
                                    <Input type="number" name="montantDep" value={montantDep} id="montantDep" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="codeNatDep">Nature de Dépense</Label>
                                    <InputGroup compact>
                                        <Select
                                            value={codeNatDep}
                                            showSearch
                                            //style={{width: 200}}
                                            style={{ width: '85%' }}
                                            placeholder="Selectionner Nature"
                                            optionFilterProp="children"
                                            onChange={this.handleChangeNature}
                                            onFocus={this.handleFocus}
                                            onBlur={this.handleBlur}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {
                                                natures && natures.length ?
                                                    natures.map((nature, k) => {
                                                        return <Option key={k} value={nature.codeNatDep}>{nature.libelleNatDep}</Option>
                                                    }) : null
                                            }

                                        </Select>
                                        <Button onClick={this.openNatureAdd} style={{ width: '15%' }} type="primary" ><i className="icon icon-add" /> AJOUTER</Button>
                                    </InputGroup>
                                </FormGroup>

                            </Col>

                        </Row>
                        <Row form>


                            <Col md={12}>
                                <FormGroup>
                                    <Label for="observation">Observation</Label>
                                    <Input type="text" name="observation" value={observation} onChange={this.handleChange} id="observation" placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                    </Form>
                </Modal>

                <Modal
                    width={800}
                    visible={isUpdateModalVisible}
                    title="Modifier la Dépense"
                    //onOk={this.handleAddOpen}
                    onCancel={this.handleCancelUpdate}
                    footer={[
                        <Button  type="primary" loading={loading} onClick={this.handleUpdateDepense}>
                            Modifier
                        </Button>,
                        <Button type="danger" onClick={this.handleCancelUpdate}>
                            Annuler
                        </Button>,

                    ]}
                >
                    <Form>
                        <Row form>
                            <Col md={3}>
                                <FormGroup>
                                    <Label for="codeDep">Code Dépense</Label>
                                    <Input disabled type="text" name="codeDep" id="codeDep" value={codeDep} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                            <Col md={9}>
                                <FormGroup>
                                    <Label for="libelleDep">Désignation</Label>
                                    <Input type="text" name="libelleDep" value={libelleDep} onChange={this.handleChange} id="libelleDep" placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="montantDep">Montant Opération</Label>
                                    <Input type="number" name="montantDep" value={montantDep} id="montantDep" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="dateDep">Date Opération</Label>
                                    <Input disabled type="date" name="dateDep" value={dateDep} id="dateDep" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="codeNatDep">Nature de Dépense</Label>
                                    <InputGroup compact>
                                        <Select
                                            value={codeNatDep}
                                            showSearch
                                            //style={{width: 200}}
                                            style={{ width: '85%' }}
                                            placeholder="Selectionner Nature"
                                            optionFilterProp="children"
                                            onChange={this.handleChangeNature}
                                            onFocus={this.handleFocus}
                                            onBlur={this.handleBlur}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {
                                                natures && natures.length ?
                                                    natures.map((nature, k) => {
                                                        return <Option key={k} value={nature.codeNatDep}>{nature.libelleNatDep}</Option>
                                                    }) : null
                                            }

                                        </Select>
                                        <Button onClick={this.openNatureAdd} style={{ width: '15%' }} type="primary" ><i className="icon icon-add" /> AJOUTER</Button>
                                    </InputGroup>
                                </FormGroup>

                            </Col>

                        </Row>
                        <Row form>


                            <Col md={12}>
                                <FormGroup>
                                    <Label for="observation">Observation</Label>
                                    <Input type="text" name="observation" value={observation} onChange={this.handleChange} id="observation" placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="agence">Agence</Label>
                                    <Input disabled type="text" name="agence" value={agence} id="agence" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="user">Opérateur</Label>
                                    <Input disabled type="text" name="user" value={user} id="user" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                    </Form>
                </Modal>

                <Modal
                    width={800}
                    visible={isModalVisible}
                    title="Détails Détails"
                    onOk={this.handleCancel}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button type="danger" onClick={this.handleCancel}>
                            Retour
                        </Button>,
                        /*<Button  type="primary" loading={loading} onClick={this.handleCancel}>
                          Envoyer
                        </Button>,
                       */
                    ]}
                >
                    <Form>
                        <Row form>
                            <Col md={3}>
                                <FormGroup>
                                    <Label for="codeDep">Code Dépense</Label>
                                    <Input disabled type="text" name="codeDep" id="codeDep" value={codeDep} onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                            <Col md={9}>
                                <FormGroup>
                                    <Label for="libelleDep">Désignation</Label>
                                    <Input disabled type="text" name="libelleDep" value={libelleDep} onChange={this.handleChange} id="libelleDep" placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="montantDep">Montant Opération</Label>
                                    <Input disabled type="number" name="montantDep" value={montantDep} id="montantDep" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="dateDep">Date Opération</Label>
                                    <Input disabled type="text" name="dateDep" value={dateDep} id="dateDep" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="codeNatDep">Nature de Dépense</Label>
                                    <InputGroup compact>
                                        <Select
                                            disabled
                                            value={codeNatDep}
                                            showSearch
                                            //style={{width: 200}}
                                            style={{ width: '85%' }}
                                            placeholder="Selectionner Nature"
                                            optionFilterProp="children"
                                            onChange={this.handleChangeNature}
                                            onFocus={this.handleFocus}
                                            onBlur={this.handleBlur}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {
                                                natures && natures.length ?
                                                    natures.map((nature, k) => {
                                                        return <Option key={k} value={nature.codeNatDep}>{nature.libelleNatDep}</Option>
                                                    }) : null
                                            }

                                        </Select>
                                        <Button disabled onClick={this.openNatureAdd} style={{ width: '15%' }} type="primary" ><i className="icon icon-add" /> AJOUTER</Button>
                                    </InputGroup>
                                </FormGroup>

                            </Col>

                        </Row>
                        <Row form>


                            <Col md={12}>
                                <FormGroup>
                                    <Label for="observation">Observation</Label>
                                    <Input disabled type="text" name="observation" value={observation} onChange={this.handleChange} id="observation" placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="agence">Agence</Label>
                                    <Input disabled type="text" name="agence" value={agence} id="agence" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="user">Opérateur</Label>
                                    <Input disabled type="text" name="user" value={user} id="user" onChange={this.handleChange} placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>

                    </Form>
                </Modal>

                <Modal
                    width={600}
                    visible={isAddNatureModalVisible}
                    title="Ajouter une Catégorie"
                    //onOk={this.handleAddOpen}
                    onCancel={this.openNatureAdd}
                    footer={[
                        <Button  type="primary" loading={loading} onClick={this.handleAddNature}>
                            Envoyer
                        </Button>,
                        <Button type="danger" onClick={this.openNatureAdd}>
                            Annuler
                        </Button>,

                    ]}
                >
                    <Form>
                        <Row form>

                            <Col md={12}>
                                <FormGroup>
                                    <Label for="libelleNatDep">Libellé</Label>
                                    <Input type="text" name="libelleNatDep" value={libelleNatDep} onChange={this.handleChange} id="libelleNatDep" placeholder="" />
                                </FormGroup>
                            </Col>
                        </Row>


                    </Form>
                </Modal>

            </div>
        )
    }
}


export default Depenses;
